<template>
  <v-menu>
    <template #activator="{ on: { click }, attrs }">
      <mcs-btn
        small
        rounded
        outlined
        color="black"
        class="white ml-2 px-0"
        style="min-width: 35px"
        v-bind="attrs"
        @click="click"
      >
        <v-icon small> mdi-layers-outline </v-icon>
      </mcs-btn>
    </template>
    <v-list dense>
      <template v-for="(item, j) in styles">
        <v-list-item
          :key="j"
          @click="select(item.id)"
        >
          <v-list-item-action>
            <v-list-item-title>
              {{ item.name }}
            </v-list-item-title>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { ENUMS } from '@/utils/constants';
export default {
  props: {},
  data() {
    return {
      styles: [
        { id: ENUMS.SNAILBLAST.MAP_STYLES.STREETS, name: 'Classic' },
        { id: ENUMS.SNAILBLAST.MAP_STYLES.SATELLITES, name: 'Satellite' }
      ]
    };
  },
  methods: {
    select(id) {
      this.$emit('select', id);
    }
  }
};
</script>

<style lang="scss" scoped>
.float {
  position: absolute;
  z-index: 1;
}
</style>
